module.exports = __webpack_public_path__ + "images/third-place.png";